import { render, staticRenderFns } from "./ButtonSecondaryForward.vue?vue&type=template&id=d3167e94&scoped=true"
import script from "./ButtonSecondaryForward.vue?vue&type=script&lang=js"
export * from "./ButtonSecondaryForward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3167e94",
  null
  
)

export default component.exports